import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import { isEmpty, result, size } from "lodash"
import * as moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import classNames from "classnames"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {showSuccessToast} from "helpers/function_helper"
import ReactDrawer from 'react-drawer';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
} from "reactstrap"
import RightDrawer from "../../components/Common/RightDrawer"
//redux
import { useSelector, useDispatch } from "react-redux"
import SweetAlert from "react-bootstrap-sweetalert"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getPurchaseEntryList } from "helpers/backend_helper"
import { deleteItemDirect as onDeleteItemDirect } from "helpers/backend_helper"
import Loader from "components/Common/Loader"

const PurchaseEntryList = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    getPurshaseLists()
  }, []);

  async function getPurshaseLists(){
    setShowLoading(true)
    getPurchaseEntryList().then(result => {
      setPurchaseEntryList(result)
      setShowLoading(false)
    })
  }

  const [purchaseEntryList, setPurchaseEntryList] = useState([])

  const [isEdit, setIsEdit] = useState(false)

  const [newItemToAdd, setNewItemToAdd] = useState()
  const [position, setPosition] = useState()
  const [open, setOpen] = useState(false)
  const [detailsForEdit, setDetailsForEdit] = useState()
  const [showDeletePopUp, setShowDeletePopUp] = useState(false)
  const [showErrorPopUp, setShowErrorPopUp] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [deleteMessage, setDeleteMessage] = useState('')
  const [itemToDelete, setItemToDelete] = useState()
  const [showLoading, setShowLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  
  function addNewItem(item) {
    setPosition('right')
    setOpen(!open)
    setNewItemToAdd(item)
  }
  const onDrawerClose = () => {
    setOpen(false);
  }
  const onNewlyAddedValue = (value) => {
  }
  //pagination customization
  const pageOptions = {
    sizePerPage: 10,
    totalSize: size(purchaseEntryList), 
    custom: true,
    onPageChange: (page, sizePerPage) => {
      setCurrentPage(page)
    }
  }
  const { SearchBar } = Search

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const PurchaseEntryListColumns = () => [
    {
      dataField: "id",
      text: "ID",
      sort: true,
      sortValue: (cell, row) => Number(cell),
    },
    {
      dataField: "entrydate",
      text: "Entry Date",
      sort: true,
      formatter: (cellContent, row) => handleValidDate(cellContent),
      filterValue: (cellContent, row) => handleValidDate(cellContent),
    },
    {
      dataField: "invoicedate",
      text: "Invoice Date",
      sort: true,
      formatter: (cellContent, row) => handleValidDate(cellContent),
      filterValue: (cellContent, row) => handleValidDate(cellContent),
    },
    {
      dataField: "suppinvoiceno",
      text: "Supp. Invoice No.",
    },
    {
      dataField: "suppliername",
      text: "Supplier Name",
      sort: true,
    },
    {
      dataField: "grandtotal",
      text: "Amount",
      sort: true,
      formatter: (cellContent, row) => (Number(cellContent).toLocaleString('en-IN',{minimumFractionDigits: 2})),
      
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cellContent, row) => (
        <Badge className={cellContent== "ACTIVE"? "font-size-12 bg-success badge-success":"font-size-12 bg-warning badge-warning"}>
          {cellContent}
        </Badge>
      ),
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      formatter: (cellContent, item) => (
        <>
          <div className="d-flex gap-3">
            <Link
              to={"/edit-purchaseentry/"+item.id}
              className="text-success"
            >
              <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
              </UncontrolledTooltip>
            </Link>
          </div>
        </>
      ),
    },
  ]

  const handleEditClick = arg =>{
    setDetailsForEdit(arg)
    setIsEdit(true)
    addNewItem('Supplier')
  }

  const handleDeleteClick = arg => {
    setItemToDelete(arg)
    setDeleteMessage(arg.label)
    setShowDeletePopUp(true)
  }

  const confirmDelete = async () =>{
    setShowDeletePopUp(false)
    setShowLoading(true)
    const response =  await onDeleteItemDirect({
      'key': itemToDelete.value,
      'value' : 'Supplier'
    }, '')
    setShowLoading(false)
    if(response.status == 'success'){
      dispatch(onGetAllSuppliers(false))
      showSuccessToast('Deleted Successfully!!!')
    }
    else if(response.status == 'failure'){
      setErrorMessage(response.errorResponse)
      setShowErrorPopUp(true)
    }
  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>View All Purchase Entry | Flamingo</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Purchase" breadcrumbItem="View All Purchase Entries" />
          <Loader showLoader={showLoading} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={PurchaseEntryListColumns()}
                    data={purchaseEntryList}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="id"
                        data={purchaseEntryList}
                        columns={PurchaseEntryListColumns()}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="4">
                              <div className={classNames({"d-none": currentPage !== 1},"search-box me-2 mb-2 d-inline-block")}>
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="8">
                                <div className="text-sm-end">
                                  <Link
                                    to="/add-purchase"
                                    role="button"
                                    className="btn btn-success btn-rounded  mb-2 me-2"
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Add New Purchase Entry
                                  </Link>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField="id"
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    classes={
                                      "table align-middle  table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ReactDrawer
        open={open}
        position={position}
        onClose={onDrawerClose}
      >
        <RightDrawer 
          onClose={onDrawerClose} 
          currentItem={newItemToAdd} 
          onNewlyAddedValue={onNewlyAddedValue}
          selectedId={null}
          detailsForEdit={detailsForEdit}
          isEdit={isEdit}
        />
      </ReactDrawer>
      {showDeletePopUp ? (
        <SweetAlert
          title="Are you sure?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDelete()
          }}
          onCancel={() => {
            setShowDeletePopUp(false)
          }}
        >
          <p>Deleting Supplier : <b>{deleteMessage}</b></p>
          You won't be able to revert this!
        </SweetAlert>
      ) : null}
      {showErrorPopUp ? (
        <SweetAlert
          error
          title="Failed"
          onConfirm={() => {
            setShowErrorPopUp(false)
          }}
        >
          {errorMessage}
        </SweetAlert>
      ) : null}
    </React.Fragment>
  )
}

PurchaseEntryList.propTypes = {
  purchaseEntryList: PropTypes.array,
  onGetAllSuppliers: PropTypes.func,
}

export default withRouter(PurchaseEntryList)
